<div class="default-logo-version">
  <figure class="item">
    <img appImageSelector alt="mt-image" [imageType]="'logo'" [imageKey]="'logo'" [error]="imgError" (error)="errorHandler()">
    <figcaption class="caption" *ngIf="includeVersion">
      {{'version' | lang: version | lowercase}}
    </figcaption>
  </figure>
</div>